
import GoogleMyBusinessLoginCard from '@/components/google/GoogleMyBusinessLoginCard.vue';
import GoogleMyBusinessSettingsCard from '@/components/google/GoogleMyBusinessSettingsCard.vue';
import PlatformLatestPostsCard from '@/components/social/PlatformLatestPostsCard.vue';
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, GoogleBusinessPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-social-platform-google-my-business',
  components: {
    GoogleMyBusinessLoginCard,
    GoogleMyBusinessSettingsCard,
    PlatformLatestPostsCard,
  },
})
export default class ProjectSocialPlatformGoogleMyBusiness extends mixins(ProjectViewMixin) {
  readonly googleBusinessPlatform = SupportedPlatform.GoogleBusiness;

  get isPlatformConnected(): boolean {
    const meta = SOCIAL_PLATFORMS_METADATA.find(
      (m) => m.value === SupportedPlatform.GoogleBusiness,
    );
    return !!this.bot && !!meta?.isConnected?.(this.bot);
  }

  onConnect(data: Partial<GoogleBusinessPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.GoogleBusiness]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.GoogleBusiness]: {
          accountId: '',
          locationId: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
